import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type ShoreDeptTypeRequest = CommonTableRequest;

export interface ShoreDeptType {
    id: number;
    type: string | null;
    code: string | null;
    isListDepartment: boolean;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface ShoreDeptTypeResponse {
    data: ShoreDeptType[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateShoreDeptTypeRequest {
    type: string;
    code: string;
    isListDepartment: boolean;
}

export type UpdateShoreDeptTypeRequest = CreateShoreDeptTypeRequest;

export const getApiShoreDeptType = (
    clientId: number,
    tenantAlias: string,
    payload: ShoreDeptTypeRequest,
): Promise<ShoreDeptTypeResponse> =>
    httpApi
        .post<ShoreDeptTypeResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-department-types/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiShoreDeptType = (
    clientId: number,
    tenantAlias: string,
    payload: CreateShoreDeptTypeRequest,
): Promise<ShoreDeptType> =>
    httpApi
        .post<ShoreDeptType>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-department-types`, payload)
        .then(({ data }) => data);

export const updateApiShoreDeptType = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateShoreDeptTypeRequest,
): Promise<ShoreDeptType> =>
    httpApi
        .put<ShoreDeptType>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-department-types/${id}`,
            payload,
        )
        .then(({ data }) => data);

export const deleteApiShoreDeptType = (clientId: number, tenantAlias: string, id: number): Promise<ShoreDeptType> =>
    httpApi
        .delete<ShoreDeptType>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-department-types/${id}`)
        .then(({ data }) => data);
